import { useCallback, useMemo, useState, type ReactNode } from 'react'
import { NavigationPanelContext } from '../contexts/navigationPanelContext'

export function NavigationPanelProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])
  const toggle = useCallback(() => setIsOpen(prev => !prev), [])

  const value = useMemo(
    () => ({
      isOpen,
      open,
      close,
      toggle,
    }),
    [isOpen, open, close, toggle],
  )

  return (
    <NavigationPanelContext.Provider value={value}>
      {children}
    </NavigationPanelContext.Provider>
  )
}